import React from 'react';
import { Link } from 'react-router-dom';
import { useLang } from '../context/LanguageContext';
import { pickTranslated, localizePrice } from '../lib/propertyI18n';

export default function PropertyCard({ property }) {
  const { lang, t } = useLang();
  const isExternal = Boolean(property.external_url);
  const title = pickTranslated(property, lang, 'title');
  const location = pickTranslated(property, lang, 'location');
  const localizedPrice = localizePrice(property.price, t);
  const statusKey = (property.price || '').trim().toLowerCase();
  const isRented = statusKey === 'rented';
  const isSold = statusKey === 'sold';
  const statusLabel = isRented ? t.listing.status_rented : isSold ? t.listing.status_sold : null;

  const commonInner = (
    <>
      <div className="relative aspect-[4/3] overflow-hidden bg-neutral-100">
        <img
          src={property.hero}
          alt={property.title}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-[1.03]"
        />
        {statusLabel && (
          <div className="absolute top-3 left-3 bg-[#e11f3a] text-white px-2.5 py-1 text-[9px] tracking-[0.28em] uppercase font-medium shadow-sm">
            {statusLabel}
          </div>
        )}
      </div>
      <div className="pt-6 pb-2">
        <h3 className="text-[15px] tracking-[0.22em] font-normal uppercase text-black group-hover:text-[#e11f3a] transition-colors">
          {title}
        </h3>
        <div className="mt-3 flex items-baseline justify-between gap-4">
          <p className="text-[11px] tracking-[0.25em] uppercase text-neutral-500">
            {location}
          </p>
          {property.price && (
            <p className={`text-[11px] tracking-[0.25em] uppercase ${statusLabel ? 'text-[#e11f3a] font-medium' : 'text-neutral-700'}`}>
              {localizedPrice}
            </p>
          )}
        </div>
      </div>
    </>
  );

  if (isExternal) {
    return (
      <a
        href={property.external_url}
        target="_blank"
        rel="noopener noreferrer"
        className="group block overflow-hidden bg-white"
      >
        {commonInner}
      </a>
    );
  }

  return (
    <Link
      to={`/project/${property.slug}`}
      className="group block overflow-hidden bg-white"
    >
      {commonInner}
    </Link>
  );
}
